// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1mCtS","footer":"ReportModalFilter_footer__Y_Y63"};